import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.primary};
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    line-height: 1.6;
    overflow-x: hidden;
  }

  /* Remove default button styles */
  button {
    font-family: inherit;
    font-size: inherit;
    border: none;
    background: none;
    cursor: pointer;
    outline: none;
  }

  /* Remove default link styles */
  a {
    text-decoration: none;
    color: inherit;
    transition: color ${({ theme }) => theme.transitions.base};
  }

  /* Images */
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Lists */
  ul, ol {
    list-style: none;
  }

  /* Headings */
  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: 700;
    line-height: 1.2;
    color: ${({ theme }) => theme.colors.text};
  }

  h1 {
    font-size: ${({ theme }) => theme.fonts.sizes['6xl']};
  }

  h2 {
    font-size: ${({ theme }) => theme.fonts.sizes['5xl']};
  }

  h3 {
    font-size: ${({ theme }) => theme.fonts.sizes['4xl']};
  }

  h4 {
    font-size: ${({ theme }) => theme.fonts.sizes['3xl']};
  }

  h5 {
    font-size: ${({ theme }) => theme.fonts.sizes['2xl']};
  }

  h6 {
    font-size: ${({ theme }) => theme.fonts.sizes.xl};
  }

  /* Paragraphs */
  p {
    margin-bottom: ${({ theme }) => theme.spacing.md};
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  /* Selection */
  ::selection {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.text};
  }

  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.backgroundLight};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary};
    border-radius: ${({ theme }) => theme.borderRadius.full};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.primaryHover};
  }

  /* Focus styles for accessibility */
  :focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  /* Skip to main content link for accessibility */
  .skip-to-content {
    position: absolute;
    left: -9999px;
    z-index: 999;
    padding: ${({ theme }) => theme.spacing.md};
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.text};
    text-decoration: none;
    font-weight: 600;

    &:focus {
      left: ${({ theme }) => theme.spacing.md};
      top: ${({ theme }) => theme.spacing.md};
    }
  }

  /* Smooth scroll padding for fixed headers */
  html {
    scroll-padding-top: 80px;
  }

  /* Container helper class */
  .container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.spacing.md};

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      padding: 0 ${({ theme }) => theme.spacing.lg};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      padding: 0 ${({ theme }) => theme.spacing.xl};
    }
  }

  /* Responsive typography */
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    h1 {
      font-size: ${({ theme }) => theme.fonts.sizes['4xl']};
    }

    h2 {
      font-size: ${({ theme }) => theme.fonts.sizes['3xl']};
    }

    h3 {
      font-size: ${({ theme }) => theme.fonts.sizes['2xl']};
    }

    h4 {
      font-size: ${({ theme }) => theme.fonts.sizes.xl};
    }
  }
`
